export default "__VITE_ASSET__BTngn4Ta__"